import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { enableAnalytics } from "./firebase";
import "./cookie-consent.css";

const MARKETING_PATHS = [
  "/",
  "/piani",
  "/contatti",
  "/demo",
  "/app-asporto",
  "/menu-ai",
  "/menu-digitale-ristoranti",
  "/menu-digitale-pizzerie",
  "/street-food",
];

function CookieConsent() {
  const location = useLocation();

  const [visible, setVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false);

  const isMarketingPage = MARKETING_PATHS.includes(location.pathname);

  useEffect(() => {
    if (!isMarketingPage) {
      setVisible(false);
      return;
    }

    const consent = localStorage.getItem("qrmenu_cookie_consent");

    if (!consent) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [isMarketingPage, location.pathname]);

  const acceptAll = async () => {
    localStorage.setItem("qrmenu_cookie_consent", "accepted");

    await enableAnalytics();

    setVisible(false);
    setShowPreferences(false);
  };

  const rejectAll = () => {
    localStorage.setItem("qrmenu_cookie_consent", "rejected");

    setVisible(false);
    setShowPreferences(false);
  };

  const savePreferences = async () => {
    if (analyticsEnabled) {
      localStorage.setItem("qrmenu_cookie_consent", "accepted");
      await enableAnalytics();
    } else {
      localStorage.setItem("qrmenu_cookie_consent", "rejected");
    }

    setVisible(false);
    setShowPreferences(false);
  };

  if (!visible || !isMarketingPage) {
    return null;
  }

  return (
    <div className="qr-cookie-overlay">
      <div className="qr-cookie-banner">
        {!showPreferences ? (
          <>
            <div className="qr-cookie-content">
              <span className="qr-cookie-icon">🍪</span>

              <div>
                <h2>La tua privacy è importante</h2>

                <p>
                  Utilizziamo cookie tecnici necessari al funzionamento del sito
                  e, con il tuo consenso, strumenti di analisi per capire come
                  viene utilizzato QrMenu e migliorare il servizio.
                </p>
              </div>
            </div>

            <div className="qr-cookie-actions">
              <button
                type="button"
                className="qr-cookie-btn qr-cookie-btn-primary"
                onClick={acceptAll}
              >
                Accetta tutti
              </button>

              <button
                type="button"
                className="qr-cookie-btn"
                onClick={rejectAll}
              >
                Rifiuta
              </button>

              <button
                type="button"
                className="qr-cookie-link"
                onClick={() => setShowPreferences(true)}
              >
                Personalizza
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="qr-cookie-preferences">
              <div>
                <h2>Preferenze cookie</h2>

                <p>
                  Puoi scegliere quali cookie consentire.
                </p>
              </div>

              <div className="qr-cookie-option">
                <div>
                  <strong>Cookie necessari</strong>
                  <p>
                    Necessari per il corretto funzionamento del sito.
                  </p>
                </div>

                <span className="qr-cookie-required">
                  Sempre attivi
                </span>
              </div>

              <div className="qr-cookie-option">
                <div>
                  <strong>Cookie di analisi</strong>
                  <p>
                    Ci aiutano a capire come viene utilizzato il sito.
                  </p>
                </div>

                <label className="qr-cookie-switch">
                  <input
                    type="checkbox"
                    checked={analyticsEnabled}
                    onChange={(e) =>
                      setAnalyticsEnabled(e.target.checked)
                    }
                  />
                  <span className="qr-cookie-slider" />
                </label>
              </div>
            </div>

            <div className="qr-cookie-actions">
              <button
                type="button"
                className="qr-cookie-btn qr-cookie-btn-primary"
                onClick={savePreferences}
              >
                Salva preferenze
              </button>

              <button
                type="button"
                className="qr-cookie-link"
                onClick={() => setShowPreferences(false)}
              >
                Indietro
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CookieConsent;